<template>
    <ContentOrLoading>
        <div v-if="sesion" class="card">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-md-flex justify-content-md-between">
                        <h3 class="card-title my-3">
                            Precios para la sesión: {{ sesion.fecha }}
                        </h3>
                        <div>
                            <Button
                                class="m-1"
                                @click.prevent="showModal('cargarPrecios')"
                            >
                                Cargar precios de otro evento / sesión
                            </Button>
                            <CargarPrecios
                                :sesion="sesion"
                                :evento_id="evento.id"
                                @close="closeModal"
                            />
                            <Button @click="showModal('crearEntrada')" id="crearEntrada">Crear precio</Button>
                            <CreateModal :sesion="sesion" :evento_id="evento_id" :butacas="true" @close="closeModal" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <ContentOrLoading>
                            <div v-if="!loading && entradas && entradas.length > 0">
                                <div v-for="(entrada, index) in entradas" class="row mb-4" :key="index">
                                    <div class="col-6 col-md-10">
                                        <div class="row">
                                            <div class="col-12 col-md-4">
                                                <strong>{{ entrada.descripcion }}</strong>
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <i class="text-green fas fa-laptop"></i>
                                                {{ entrada.price_management_online_interno ? parseFloat(entrada.precio) : (parseFloat(entrada.precio) + parseFloat(entrada.price_management_online)) | formatear_precio }}
                                            </div>
                                            <div class="col-12 col-md-4">
                                                <i class="text-green fas fa-store"></i>
                                                {{ entrada.price_management_taquilla_interno ? parseFloat(entrada.precio) : (parseFloat(entrada.precio) + parseFloat(entrada.price_management_taquilla)) | formatear_precio }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <OpcionesDropdownComponent v-bind:options="[
                                            {
                                                type: 'action',
                                                action: () => showModal('editarEntrada-' + entrada.id),
                                                label: 'Editar',
                                            },
                                            {
                                                type: 'action',
                                                action: () => showModal('deleteEntrada-' + entrada.id),
                                                label: 'Borrar',
                                            },
                                        ]"
                                        />
                                    </div>
                                    <EditModal :sesion="sesion" :evento_id="evento_id" :entrada="entrada"
                                               :butacas="true" @close="closeModal"
                                    />
                                    <BorrarModal :evento_id="evento_id" :sesion_id="sesion.id" :entrada="entrada"
                                                 @close="closeModal"
                                    />
                                </div>
                            </div>
                            <div v-else-if="entradas && entradas.length === 0">
                                <div class="col-12">
                                    <strong>Este recinto no tiene precios</strong>
                                </div>
                            </div>
                        </ContentOrLoading>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!loadingButacas" class="card card-primary card-outline card-outline-tabs">
            <div class="card-header p-0 border-bottom-0">
                <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                    <li class="nav-item">
                        <a href="#" :class="tab == 'porPlano' ? 'nav-link active' : 'nav-link'"
                           @click.prevent="tab = 'porPlano'"
                        >
                            Configurar desde plano
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" :class="tab == 'porPlazas' ? 'nav-link active' : 'nav-link'"
                           @click.prevent="tab = 'porPlazas'"
                        >
                            Configurar por plaza/butaca
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" :class="tab == 'porSectores' ? 'nav-link active' : 'nav-link'"
                           @click.prevent="tab = 'porSectores'"
                        >
                            Configurar por sectores
                        </a>
                    </li>
                    <li class="nav-item">
                        <a href="#" :class="tab == 'general' ? 'nav-link active' : 'nav-link'"
                           @click.prevent="tab = 'general'"
                        >
                            Configuración general
                        </a>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="tab-content">
                    <ContentOrLoading>
                        <div v-if="butacas" class="tab-pane fade active show">
                            <transition name="fade" mode="out-in">
                                <div key="1" class="overlay-wrapper" v-if="tab == 'porPlano'">
                                    <PorPlanoButaca
                                        :entradas="entradas"
                                        :plazas="butacas"
                                        :recinto_id="evento.place_id"
                                        @recargar="getButacas"
                                    />
                                </div>
                                <div key="2" class="overlay-wrapper" v-if="tab == 'porPlazas'">
                                    <PorPlazas
                                        :entradas="entradas"
                                        :plazas="butacas"
                                        @recargar="getButacas"
                                    />
                                </div>
                                <div key="3" class="overlay-wrapper" v-if="tab == 'general'">
                                    <General
                                        :entradas="entradas"
                                        :recinto_id="evento.place_id"
                                        @recargar="getButacas"
                                    />
                                </div>
                                <div key="4" class="overlay-wrapper" v-if="tab == 'porSectores'">
                                    <PorSectores
                                        :entradas="entradas"
                                        :recinto_id="evento.place_id"
                                        @recargar="getButacas"
                                    />
                                </div>
                            </transition>
                        </div>
                    </ContentOrLoading>
                </div>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import CreateModal from '@/views/backend/events/sesiones/conrecinto/modals/CreateEntradaConRecinto.vue';
    import EditModal from '@/views/backend/events/sesiones/conrecinto/modals/EditarEntradaConRecinto.vue';
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
    import BorrarModal from '@/views/backend/events/sesiones/conrecinto/modals/DeleteEntradaConRecinto.vue';
    import PorPlazas from './PorPlazas.vue';
    import PorSectores from './PorSectores.vue';
    import General from './General.vue';
    import PorPlanoButaca from './PorPlanoButaca.vue';
    import CargarPrecios from '@/views/backend/events/sesiones/conrecinto/modals/CargarPrecios.vue';

    export default {
        props: {
            evento_id: {
                type: Number,
                required: true
            },
            evento:{
                type: Object
            },
            sesion_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                loadingButacas: false,
                entradas: null,
                sesion: null,
                butacas: null,
                tab: 'porPlano'
            }
        },
        created() {
            this.getSesion();
            this.getButacas();
        },
        methods: {
            getSesion() {
                this.loading = true

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.show'), params).then(res => {
                    this.sesion = res.data.data
                    this.entradas = res.data.data.entradas
                }).finally(() => (this.loading = false))
            },
            getButacas(tipo) {
                this.loadingButacas = true;

                const params = {
                    filters: {},
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    recinto_id: this.evento.place_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.settings.butacas'), params).then(res => {
                    this.butacas = res.data.data;
                
                    if (tipo) {
                        this.tab = tipo;
                    }
                }).catch(() => {
                    console.warn('Error al recuperar las butacas de la sesión');
                }).finally(() => {
                    this.loadingButacas = false;
                });
            },
            showModal(modal) {
                this.$modal.show(modal)
            },
            closeModal(modal, creado) {
                if (creado) {
                    this.getSesion();
                }
                this.$modal.hide(modal)
            },
        },
        components: { CreateModal, EditModal, OpcionesDropdownComponent, BorrarModal, PorPlanoButaca, PorPlazas, PorSectores, General, CargarPrecios }
    }
</script>